/** 会员等级 */
export const MemberLevelValue = {
    /** 免费 */
    FREE: 0,
    /** 标准 */
    STANDARD: 1,
    /** 专业 */
    PRO: 2,
    /** 高级 */
    PREMIUM: 3,
    /** 旗舰 */
    FLAGSHIP: 4,
} as const;

export type MemberLevel = (typeof MemberLevelValue)[keyof typeof MemberLevelValue];

/** 订阅类型 */
export const SubscriptionTypeValue = {
    /** 单月 */
    MONTHLY: 1,
    /** 连续包月 */
    AUTO_MONTHLY: 2,
    /** 包年 */
    YEARLY: 3,
} as const;

export type SubscriptionType = (typeof SubscriptionTypeValue)[keyof typeof SubscriptionTypeValue];

/** 订阅状态 */
export const SubscriptionStatusValue = {
    /** 生效中 */
    ACTIVE: 1,
    /** 待生效 */
    PENDING: 2,
    /** 已过期 */
    EXPIRED: 3,
    /** 已取消 */
    CANCELLED: 4,
} as const;

export type SubscriptionStatus =
    (typeof SubscriptionStatusValue)[keyof typeof SubscriptionStatusValue];

/** SKU ID 套餐唯一id */
export type SkuId = number;

/** 业务订单号 */
export type OrderId = string;
